import { SET_DRAFT_CEILING_HEIGHT } from '../actionConstants';

export const filterActions = (incomingAction: any) => {
  if (incomingAction.type === SET_DRAFT_CEILING_HEIGHT) {
    return !!incomingAction.meta?.isPersistent;
  }

  return false;
};
